import { render, staticRenderFns } from "./AsideLogo.vue?vue&type=template&id=78db4216&scoped=true&"
import script from "./AsideLogo.vue?vue&type=script&lang=js&"
export * from "./AsideLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78db4216",
  null
  
)

export default component.exports